export const TOGGLE_FORM_IS_VALID =
  'src/DrivingLicenceForm/TOGGLE_FORM_IS_VALID'

export const IS_EMAIL_VALID = 'src/DriverDetails/IS_EMAIL_VALID'
